"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CommonResponseWithPayload = exports.CommonResponse = void 0;
class CommonResponse {
}
exports.CommonResponse = CommonResponse;
class CommonResponseWithPayload extends CommonResponse {
}
exports.CommonResponseWithPayload = CommonResponseWithPayload;
//# sourceMappingURL=common-response.js.map